import React from "react";
import { h, Component } from "preact";
import { Field, reduxForm } from "redux-form";
import { required, email } from "../../../utils/Validators";
import { scrollToErrors } from "../../../utils/ScrollToError";

import InputField from "../../../components/Inputs/InputField";
import SelectField from "../../../components/Inputs/SelectField";
import SearchField from "../../../components/Inputs/SearchField";
import TextAreaField from "../../../components/Inputs/TextAreaField";
import SubmitButton from "../../../components/Inputs/SubmitButton";

import styles from "./BuyerForm.scss";

import EmailService from "../../../services/EmailService";

const loadingIcon = require("../../../assets/loading/ic_loading_ticket.svg");
const tickIcon = require("../../../assets/loading/ic_green_tick.svg");

let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class BuyerForm extends Component {
  handleSubmitForm(values) {
    const { locale } = this.props;
    let { email, firstName, lastName, enquiry, textArea, event } = values;
    if (!event) {
      return null;
    }
    if (
      re.test(String(email).toLowerCase()) &&
      firstName !== "" &&
      lastName !== "" &&
      textArea !== ""
    ) {
      if (enquiry === "Fraud") {
        if (typeof window !== "undefined") {
          window.scrollTo(0, 0);
        }
        this.setState({
          isLoading: true
        });
        EmailService.post(email, null, 2, this.constructEmail(values), locale)
          .then(response => {
            this.setState({
              isLoading: false,
              sent: true
            });
          })
          .catch(err => {});
      } else {
        if (typeof window !== "undefined") {
          window.scrollTo(0, 0);
        }
        this.setState({
          isLoading: true
        });
        EmailService.post(email, event._id, 2, this.constructEmail(values))
          .then(response => {
            this.setState({
              isLoading: false,
              sent: true
            });
          })
          .catch(err => {});
      }
    }
  }

  constructEmail(values) {
    let { firstName, lastName, enquiry, event, textArea, mobile } = values;
    const response = textArea.replace(/(\r\n|\n|\r)/gm, "<br />");
    const eventName = event.name;
    return { firstName, lastName, enquiry, eventName, response, mobile };
  }

  reset() {
    this.setState({
      isLoading: false,
      sent: false,
      possibleEvents: []
    });
  }

  clearEvents() {
    this.setState({
      possibleEvents: []
    });
  }

  eventSearch(event) {
    const { locale } = this.props;
    EmailService.getEvents(event.target.value, locale).then(results => {
      this.setState({
        possibleEvents: results.data.results
      });
    });
  }

  selectEvent(event) {
    this.setState({
      event: event.name,
      eventId: event._id
    });
  }

  constructor(props) {
    super(props);
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.constructEmail = this.constructEmail.bind(this);
    this.eventSearch = this.eventSearch.bind(this);
    this.selectEvent = this.selectEvent.bind(this);
    this.clearEvents = this.clearEvents.bind(this);
    this.reset = this.reset.bind(this);
    this.state = {
      email: null,
      firstName: null,
      lastName: null,
      event: null,
      enquiry: null,
      textArea: null,
      response: null,
      isLoading: false,
      sent: false,
      dropdown: false,
      possibleEvents: [],
      eventId: null
    };
  }

  render() {
    const { sent, isLoading, possibleEvents } = this.state;
    const { handleSubmit, reset } = this.props;
    if (sent || isLoading) {
      return (
        <div className={styles.content}>
          <div className={styles.sentWrapper}>
            {!isLoading ? (
              <div>
                <img
                  src={loadingIcon}
                  className={styles.loadingShrink}
                  alt="Loading Icon"
                />
                <img
                  src={tickIcon}
                  className={styles.tick}
                  alt="Tick Icon"
                  name="Sent Tick"
                />
              </div>
            ) : (
              <div>
                <img
                  src={loadingIcon}
                  className={styles.loading}
                  alt="Loading Icon"
                />
              </div>
            )}
            <h2>Your message has been sent!</h2>
            <p>Our support team will be in touch shortly.</p>
            <button
              className={styles.button}
              onClick={() => {
                this.reset();
                reset();
              }}
              aria-label="Send a New Message"
            >
              Send a New Message
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.content}>
        <form
          onSubmit={handleSubmit(values => {
            this.handleSubmitForm(values);
          })}
        >
          <Field
            name="email"
            component={InputField}
            placeholder="Email"
            label="Email*"
            validate={[email, required]}
            autocomplete="email"
          />
          <Field
            name="firstName"
            component={InputField}
            placeholder="First Name"
            label="First Name*"
            validate={required}
            autocomplete="given-name"
          />
          <Field
            name="lastName"
            component={InputField}
            placeholder="Last Name"
            label="Last Name*"
            validate={required}
            autocomplete="family-name"
          />
          <Field
            name="mobile"
            component={InputField}
            placeholder="Mobile"
            label="Mobile"
          />
          <Field
            name="enquiry"
            component={SelectField}
            label="Enquiry type *"
            options={[
              { value: "Lost my tickets", label: "Lost my tickets" },
              { value: "Issue purchasing", label: "Issue purchasing" },
              { value: "Event information", label: "Event information" },
              { value: "I want a refund", label: "I want a refund" },
              { value: "Payment plan", label: "Payment plan" },
              {
                value: "Change name on ticket",
                label: "Change name on ticket"
              },
              { value: "Fraud", label: "Fraud" },
              { value: "Other", label: "Other" }
            ]}
            validate={required}
          />
          <Field
            name="event"
            component={SearchField}
            placeholder="Event"
            label="Event*"
            searchFunction={this.eventSearch}
            blurFunction={this.clearEvents}
            options={possibleEvents}
            labelKey="name"
            valueKey="_id"
          />
          <Field
            name="textArea"
            component={TextAreaField}
            placeholder="How can we help?"
            label="How can we help?*"
            validate={required}
          />

          <SubmitButton />
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: "buyerForm", // a unique identifier for this form
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(BuyerForm);
